import { render, staticRenderFns } from "./pExpertCreateIndex.vue?vue&type=template&id=80a98f3e&"
import script from "./pExpertCreateIndex.vue?vue&type=script&lang=js&"
export * from "./pExpertCreateIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports